<template>
    <component :is="tag"
               :alt="alt"
               v-bind="imageSrc"
               class="wpimage"
               :class="imageClass"
               v-observe-visibility="{
                    callback: visibilityChanged,
                    throttle: throttle,
                    intersection: {
                        rootMargin: rootMargin,
                        threshold: threshold
                    }
               }">
        <slot />
    </component>
</template>

<script>
    import _get from 'lodash/get'
    import { wpMediaApi } from '@/utils/api'

    export default {
        name: "WpImage",
        props: {
            image: {
                type: Boolean | Object | Number,
                required: true,
                default: false
            },
            sizeSd: {
                type: String,
                default: 'sd'
            },
            sizeHd: {
                type: String,
                default: 'full'
            },
            isBackground: {
                type: Boolean,
                default: false
            },
            loadImmediate: {
                type: Boolean,
                default: false
            },
            throttle: {
                type: Number,
                default: 100
            },
            rootMargin: {
                type: String,
                default: '0px 0px 200px 0px'
            },
            threshold: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                loaded: false,
                loadedUrl: null,
                isVisible: false,
                visible: false,
                isAbove: false,
                isBelow: false,
            }
        },
        mounted() {
            if (this.loadImmediate) this.loadHDImage();
            if (window.innerWidth < 500) this.loadHDImage();
        },
        asyncComputed: {
            async urlHD() {
                if (!this.image) return null;

                let urlHD = this.image.url || '';
                if (this.image && this.sizeHd !== 'full') {
                    urlHD = _get(this.image,  `sizes.${this.sizeHd}`, this.image.url)
                }

                await this.loadImage(urlHD);

                return urlHD
            }
        },
        computed: {
            url() {
                if (!this.image) return null;

                return _get(this.image, `sizes.${this.sizeSd}`, 'sizes.sd');
            },
            tag() {
                return this.isBackground ? 'div':'img'
            },
            alt() {
                return this.image ? this.image.title:''
            },
            imageClass() {
                return this.loaded ? 'loaded':'loading';
            },
            imageSrc() {
                const url = this.loaded && this.urlHD ? this.urlHD : this.url;

                if (!url) return {};
                return this.isBackground ? { style: { backgroundImage: `url(${url})` } } : { src: url };
            }
        },
        methods: {
            loadImage(src) {
                return new Promise((resolve, reject) => {
                    const image = new Image();
                    image.onload = resolve;
                    image.onerror = reject;
                    image.src = src;
                })
            },
            loadHDImage() {
                this.loaded = true;
                this.$emit('loaded');
            },
            visibilityChanged(isVisible, element) {
                this.isVisible = isVisible;
                if (isVisible && !this.loaded) this.loadHDImage();
            },
            async getImageData() {
                return this.image = await wpMediaApi.get(`${this.image}`).then(res => res.data);
            }
        },
        watch: {
            image: {
                immediate: true,
                handler(image, oldImage) {
                    if (typeof image === 'number') {
                        this.getImageData();
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    .wpimage.loading {
        filter: blur(3px);
        transition: filter 0.3s;
        position: relative;
    }
</style>